import BaseApp from '@spa/apps/trustup-pro-base-js/BaseApp';
import WebsocketListener from './WebsocketListener';
import TimeActivityEndpoint from './endpoints/TimeActivityEndpoint';
import CalendarEventEndpoint from './endpoints/CalendarEventEndpoint';

export default class Planning extends BaseApp
{

    setup()
    {
        this.endpoints = {
            timeActivity: new TimeActivityEndpoint(),
            calendarEvent: new CalendarEventEndpoint()
        };

        this.websocketListener = new WebsocketListener().init();
    }

    // getComponentsPath()
    // {
    //     return './components';
    // }

}